export default class LocationLayerVersion {
  constructor ({ _id, versionNumber, sourcePfFileId, tilesS3Key, tileProcessing, zoomLevels, createdByUserId, created, isUsed }) {
    this._id = _id
    this.versionNumber = versionNumber
    this.sourcePfFileId = sourcePfFileId
    this.tilesS3Key = tilesS3Key
    this.tileProcessing = {
      status: tileProcessing.status,
      startedAt: tileProcessing.startedAt,
      finishedAt: tileProcessing.finishedAt,
      originalDpi: tileProcessing.originalDpi,
      originalWidth: tileProcessing.originalWidth,
      originalHeight: tileProcessing.originalHeight,
      scaledWidth: tileProcessing.scaledWidth,
      scaledHeight: tileProcessing.scaledHeight,
      tilePackageFileSize: tileProcessing.tilePackageFileSize,
    }
    this.zoomLevels = zoomLevels
    this.createdByUserId = createdByUserId
    this.created = created
    this.isUsed = isUsed
  }
}
